export { hu } from '@payloadcms/translations/languages/hu'
